// removed by extract-text-webpack-plugin
module.exports = {"valueBlack":"#222628","borderGray":"#D3D6DC","placeholderGray":"#9297A3","errorRed":"#DC001C","arrow":"arrow-1bApE","slim":"slim-2DRs8 slim-2C1LB","inputError":"inputError-2GZIb","showError":"showError-3ZBiL undefined"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/SingleSelectField/_singleSelectField.css
// module id = 1193
// module chunks = 1